import { Label } from '@/shared/models/view/labels-viewmodel';
import { ILabel } from '@/shared/models/interface/labels-model';

export class LabelMapper {
    public mapLabel(label: ILabel): Label {
        return new Label(
            label.itemKey,
            label.text,
            label.helpText,
            label.url
        )
    }
}